import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageKeyOptions, LocalStorageService } from 'src/app/core/local-storage.service';
import { TitleService } from 'src/app/services/title-service.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  height = window.innerHeight - 80;
  constructor(private route: ActivatedRoute,private local: LocalStorageService, private titleService: TitleService) {
    
    this.route.data.subscribe(data => {
      if (data.cred.result) {
        this.local.setItem(LocalStorageKeyOptions.Privileges, data.cred.result);
      }     
    });
  }

  ngOnInit(): void {
    this.titleService.init();

  }

}
